import { Alert, Button, Snackbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import socketService from '../../helpers/utils/socketService';
import { setNotificationCount } from '../../states/login/loginSlice';

const AlertSnackbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profile = useSelector((state) => state?.login?.profile);

  const [alert, setAlert] = useState(null);
  const [alertMessage, setAlertMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severityType, setSeverityType] = useState('success');
  const [targetRoute, setTargetRoute] = useState(''); // État pour la route cible

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleNavigate = () => {
    if (targetRoute) {
      navigate(targetRoute); // Naviguer vers la route cible
      setOpenSnackbar(false); // Fermer le snackbar après la navigation
    }
  };

  useEffect(() => {
    if (profile) {
      socketService.connect(import.meta.env.VITE_API_URL, profile);

      const handleAlert = ({ content, severityType, data }) => {
        setAlert({
          message: content,
          severityType: severityType,
          targetRoute:
            data?.type === 'Task'
              ? `/project/${data?.task?.ticket?.project?._id}/tickets/${data?.task?.ticket?._id}/tasks/${data?.task?._id}`
              : '',
        });
      };

      const handleSetNotificationCount = ({ notificationCount }) => {
        dispatch(setNotificationCount(notificationCount));
      };

      socketService.onNotification('alert', handleAlert);
      socketService.onNotification(
        'notificationCount',
        handleSetNotificationCount
      );

      const handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
          socketService.emit('userStatusChanged', {
            userId: profile._id,
            status: 'inactive',
          });
        } else {
          socketService.emit('userStatusChanged', {
            userId: profile._id,
            status: 'active',
          });
        }
      };

      document.addEventListener('visibilitychange', handleVisibilityChange);

      return () => {
        socketService.offNotification('alert');
        socketService.offNotification('notificationCount');
        document.removeEventListener(
          'visibilitychange',
          handleVisibilityChange
        );
      };
    }
  }, [profile]);

  useEffect(() => {
    if (alert) {
      setAlertMessage(alert.message);
      setSeverityType(alert.severityType);
      setTargetRoute(alert.targetRoute);
      setOpenSnackbar(true);
    }
  }, [alert]);

  return (
    <Snackbar
      open={openSnackbar}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Alert
        onClose={handleCloseSnackbar}
        severity={severityType} // "error", "success", etc.
        color={severityType} // "error", "success", etc.
        variant="standard"
        iconMapping={{
          success: <span>✅</span>,
          error: <span>❌</span>,
          warning: <span>⚠️</span>,
          info: <span>ℹ️</span>,
        }}
        sx={{
          width: '100%',
          fontSize: '18px', // Taille du texte plus grande
          fontWeight: 'bold', // Texte en gras pour plus de visibilité
          padding: '20px', // Un peu plus de padding pour l'espacement
          backgroundColor: severityType, // Couleur d'arrière-plan selon la gravité
          borderRadius: '8px', // Bords arrondis pour l'esthétique
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // Ombre légère pour un effet de profondeur
          textAlign: 'center', // Centrer le texte
        }}
      >
        {alertMessage}
        {targetRoute && (
          <Button
            onClick={handleNavigate}
            sx={{
              color: 'white',
              marginLeft: '20px',
              textTransform: 'uppercase',
              fontWeight: 'bold',
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
              borderRadius: '8px',
              padding: '6px 16px',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
              },
            }}
          >
            Ouvrir
          </Button>
        )}
      </Alert>
    </Snackbar>
  );
};

export default AlertSnackbar;
